/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiegeSocialSelectorGridDto
 */
export interface SiegeSocialSelectorGridDto {
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialSelectorGridDto
     */
    idsiegeSocial?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SiegeSocialSelectorGridDto
     */
    formationCanHaveApprenants?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SiegeSocialSelectorGridDto
     */
    nbContrats?: number;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialSelectorGridDto
     */
    denominationSociale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialSelectorGridDto
     */
    gsm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialSelectorGridDto
     */
    telephone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialSelectorGridDto
     */
    nomPatron?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialSelectorGridDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialSelectorGridDto
     */
    localite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialSelectorGridDto
     */
    numeroBce?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SiegeSocialSelectorGridDto
     */
    chefEntreprisePrincipal?: string | null;
}

/**
 * Check if a given object implements the SiegeSocialSelectorGridDto interface.
 */
export function instanceOfSiegeSocialSelectorGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeSocialSelectorGridDtoFromJSON(json: any): SiegeSocialSelectorGridDto {
    return SiegeSocialSelectorGridDtoFromJSONTyped(json, false);
}

export function SiegeSocialSelectorGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeSocialSelectorGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idsiegeSocial': !exists(json, 'idsiegeSocial') ? undefined : json['idsiegeSocial'],
        'formationCanHaveApprenants': !exists(json, 'formationCanHaveApprenants') ? undefined : json['formationCanHaveApprenants'],
        'nbContrats': !exists(json, 'nbContrats') ? undefined : json['nbContrats'],
        'denominationSociale': !exists(json, 'denominationSociale') ? undefined : json['denominationSociale'],
        'gsm': !exists(json, 'gsm') ? undefined : json['gsm'],
        'telephone': !exists(json, 'telephone') ? undefined : json['telephone'],
        'nomPatron': !exists(json, 'nomPatron') ? undefined : json['nomPatron'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'localite': !exists(json, 'localite') ? undefined : json['localite'],
        'numeroBce': !exists(json, 'numeroBce') ? undefined : json['numeroBce'],
        'chefEntreprisePrincipal': !exists(json, 'chefEntreprisePrincipal') ? undefined : json['chefEntreprisePrincipal'],
    };
}

export function SiegeSocialSelectorGridDtoToJSON(value?: SiegeSocialSelectorGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idsiegeSocial': value.idsiegeSocial,
        'formationCanHaveApprenants': value.formationCanHaveApprenants,
        'nbContrats': value.nbContrats,
        'denominationSociale': value.denominationSociale,
        'gsm': value.gsm,
        'telephone': value.telephone,
        'nomPatron': value.nomPatron,
        'email': value.email,
        'localite': value.localite,
        'numeroBce': value.numeroBce,
        'chefEntreprisePrincipal': value.chefEntreprisePrincipal,
    };
}

